import React from 'react';

import { InputAdornment } from '@material-ui/core';
import styled from 'styled-components';
import { NewStyledIconButton, StyledTextField } from 'styles/common';

import { CrossThickIcon, SearchIcon } from 'constants/icons';
import theme from 'constants/theme';

const CustomStyledTextField = styled(StyledTextField)`
  .MuiOutlinedInput-input {
    padding: 13px 34px 13px 6px;
  }
  .MuiOutlinedInput-adornedStart {
    padding-left: 16px;
  }
  .MuiInputBase-input {
    font-size: 14px;
  }
  .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) => props.theme.palette.borders.lighterGrey};
  }
  &.MuiFormControl-root {
    justify-content: center;
  }
`;
const SearchTextField = ({ text, onChange, id = '', placeholder = '', width = '100%' }) => {
  const clearTextAdornment = (
    <InputAdornment position="end">
      <NewStyledIconButton
        circular
        onClick={() => {
          onChange('');
        }}
        padding="large"
      >
        <CrossThickIcon color={theme.palette.icons.grey2} size="fixed12px" />
      </NewStyledIconButton>
    </InputAdornment>
  );

  return (
    <CustomStyledTextField
      fullWidth
      variant="outlined"
      id={id}
      placeholder={placeholder}
      style={{ width }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon size="fixed12px" />
          </InputAdornment>
        ),
        endAdornment: text ? clearTextAdornment : null,
      }}
      value={text}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};

export default SearchTextField;
